import type { KudoContentObjectDetail, KudoContentObjectList, PublicKudoContentObject } from 'models';
import { Attachments } from 'features/attachments';
import { ContentObjectTextContent } from '../../../../content-object-text-content';
import { Kudo } from './kudo';

type P = {
  item: KudoContentObjectDetail | KudoContentObjectList | PublicKudoContentObject;
};

const KudoRendererBody = ({ item }: P) => (
  <>
    <Kudo kudo={item.kudo} />
    <ContentObjectTextContent
      contentId={item.kudo.id}
      htmlContent={item.kudo.htmlContent}
      itemType={item.type}
      textContent={item.kudo.textContent}
    />
    <Attachments attachments={item.attachments} />
  </>
);

export default KudoRendererBody;
